"use client";

import { Card, CardContent } from "@/components/ui/card";

import { Input } from "@/components/ui/input";
import type { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function TokenInputCard({
  label,
  balanceDisplay,
  value,
  onChange,
  loading,
  balanceLoading,
  after,
  error,
  autoFocus,
}: {
  label: ReactNode;
  balanceDisplay: string;
  value: string;
  onChange?: (value: string) => void;
  loading?: boolean;
  balanceLoading?: boolean;
  after?: ReactNode;
  error?: string;
  autoFocus?: boolean;
}) {
  return (
    <div>
      <Card className="bg-muted">
        <CardContent>
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>{label}</span>
            {balanceLoading ? (
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-20 rounded-full bg-foreground/15" />
              </div>
            ) : (
              <span>Balance: {balanceDisplay}</span>
            )}
          </div>
          <div className="mt-2 flex flex-wrap items-center justify-between gap-x-2 gap-y-1">
            <div className="min-w-0 flex-1">
              {onChange ? (
                <Input
                  type="number"
                  inputMode="decimal"
                  min="0"
                  step="any"
                  autoFocus={autoFocus}
                  className="h-auto min-w-0 border-none bg-transparent p-0 text-[length:var(--amount-font)] tabular-nums shadow-none focus-visible:ring-0 md:text-[length:var(--amount-font)] dark:bg-transparent [-moz-appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                  placeholder="0.0"
                  value={value}
                  onChange={(e) => onChange(e.target.value.replace(/-/g, ""))}
                />
              ) : (
                <div
                  key={loading ? "loading" : value}
                  className="animate-in truncate text-[length:var(--amount-font)] tabular-nums text-muted-foreground fade-in-0 duration-200"
                >
                  {loading ? <span className="inline-block animate-pulse">…</span> : value || "0.0"}
                </div>
              )}
            </div>
            <div className="shrink-0">{after}</div>
          </div>
        </CardContent>
      </Card>
      {error && (
        <p className="mt-2 animate-in fade-in-0 slide-in-from-top-1 text-xs text-destructive duration-200">{error}</p>
      )}
    </div>
  );
}
